import type { Section } from '@common/formEngine/formEngine.types';
import type { DeepPickPath } from '@common/utils/deepPickUtils';
import type { ExternalReferralContentKeys } from '@common/validation/customControls/externalReferral';
import type { HearingLossAudiologistConsultDataBase } from '@common/validation/customControls/hearingLoss/hearingLossAudiologistConsultDataBase';
import { hearingLossAudiologistConsultSectionsBase } from '@common/validation/customControls/hearingLoss/hearingLossAudiologistConsultDataBase';

export type HearingLossAudiologistFollowUpConsultData = HearingLossAudiologistConsultDataBase;
export type HearingLossAudiologistFollowUpConsultKey = DeepPickPath<HearingLossAudiologistFollowUpConsultData>;

export const hearingLossAudiologistFollowUpConsultSections: Section<
    HearingLossAudiologistFollowUpConsultData,
    ExternalReferralContentKeys
>[] = hearingLossAudiologistConsultSectionsBase;
